<template>
  <div class="form-group">
    <div class="mar-lt-20">
      <label class="pad-bt-5">{{$t('upload.uploadLabel')}}</label>
      <el-upload
        action=""
        :on-change="handleChange"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :limit="1"
        :auto-upload="false"
        accept='.csv'
        ref="upload">
        <el-button slot="trigger" class="btn add" size="small" type="primary">{{$t('upload.browse')}}</el-button>
        <el-button
          :disabled="!canUpload"
          style="margin-left: 10px;"
          class="btn add"
          size="small"
          type="primary"
          @click="upload"
        >{{$t('upload.upload')}}</el-button>
        <div class="el-upload__tip" slot="tip">{{$t('upload.file')}} .csv</div>
        <span class="el-upload-list__item-actions"></span>
      </el-upload>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'

  export default {
    name: 'import-products-input',
    inheritAttrs: false,
    props: {
      location: Object
    },
    data () {
      return {
        apiUrl: '',
        file: null,
        originalFilename: null,
        uploading: false
      }
    },
    computed: {
      canUpload () {
        return !!this.file && !this.uploading
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
    },
    methods: {
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pdfSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
        }
        return isOkSize
      },
      handleChange (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 25
        const isPdf = file.raw.type === 'text/csv' || (file.name && file.name.toLowerCase().endsWith('.csv'))
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pdfSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
        } else if (!isPdf) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.wrongFormat'),
            position: 'top-end',
            showConfirmButton: true,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
        } else {
          self.originalFilename = file.name
          self.getBase64(file.raw).then(
            (base64enc) => {
              self.file = base64enc
            }
          )
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.$refs.upload.files = []
          this.file = null
          this.originalFilename = null
        }
      },
      handleExceed (files, fileList) {
        var self = this
        swal({
          toast: true,
          text: self.$t('validations.removePhoto'),
          type: 'warning',
          position: 'top-end',
          showConfirmButton: true
        })
      },
      getBase64 (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })
      },
      upload () {
        if (!this.canUpload) {
          return
        }
        this.uploading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.$session.get('selectedCompany'),
          csv: this.file,
          original_filename: this.originalFilename
        }

        this.apiRequest('/import-location/products/', 'POST', data, (response) => {
          this.uploading = false
          if (response && response.status && response.data && response.data.id) {
            const importId = response.data.id
            this.trackAdminEvent('ADMIN_PRODUCT_IMPORT_CREATED', 'product_import', importId, {
              product_import_id: importId,
              location_id: this.location.true_id,
              original_filename: this.originalFilename,
              total_rows: response.data.total_rows != null ? response.data.total_rows : null,
              pending_rows: response.data.pending_rows != null ? response.data.pending_rows : null,
              error_rows: response.data.error_rows != null ? response.data.error_rows : null,
              price_profiles_id: response.data.price_profiles_id != null ? response.data.price_profiles_id : null,
              response: response
            })
            swal({
              toast: true,
              text: this.$t('productImport.uploadSuccess'),
              type: 'success',
              position: 'top-end',
              showConfirmButton: false,
              timer: 2500
            })
            this.file = null
            this.originalFilename = null
            if (this.$refs.upload) {
              this.$refs.upload.clearFiles()
            }
            this.$router.push(`/locations/${this.location.true_id}/product-imports/${importId}`)
          } else {
            swal({
              toast: true,
              text: (response && response.data) || this.$t('general.error'),
              type: 'error',
              position: 'top-end',
              showConfirmButton: false,
              timer: 4000
            })
          }
        })
      }
    }
  }
</script>

<style>
  p {
    overflow: hidden;
  }
  .mb-5 {
    margin-bottom: 2rem;
  }
  .ml-4 {
    margin-left: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/ImportProductsInput.vue